import NewsFeed from './components/NewsFeed'
import CurrencyConverter from './components/CurrencyConverter';
import FearGreed from './components/FearGreed';

function App() {
    return ( 
        <div className = "app">
        <FearGreed / >
        <CurrencyConverter / >
        <NewsFeed  / >
            
        </div>
    );
}

export default App;
